export function mergedContent(levelContentData) {
  const merged = [];
  const sortedData = levelContentData
    .filter(item => item.level !== 9999)
    .sort((a, b) => a.level - b.level);

  for (let i = 0; i < sortedData.length; i++) {
    const currentLevel = sortedData[i];
    const allSubjects = [];
    const allFlatUtils = [];

    for (let j = 0; j <= i; j++) {
      const sourceLevel = sortedData[j];
      const subjects = sourceLevel.subjects || [
        {
          title: sourceLevel.contentItems?.[0] || "General",
          videos: sourceLevel.videos || [],
          lectures: sourceLevel.lectures || [],
          docs: sourceLevel.docs || [],
          utils: sourceLevel.utils || []
        }
      ];
      
      subjects.forEach(subject => {
        allSubjects.push({
          ...subject,
          fromLevel: sourceLevel.level,
          fromTitle: Array.isArray(sourceLevel.title)
            ? sourceLevel.title[0]
            : sourceLevel.title
        });
      });
    

    if (Array.isArray(sourceLevel.flatUtils)) {
      allFlatUtils.push(...sourceLevel.flatUtils);
      }
    }
    merged.push({
      level: currentLevel.level,
      title: currentLevel.title,
      subjects: allSubjects,
      flatUtils: allFlatUtils
    });
  }

  return merged;
}
